import { createContext } from "react";

interface CopilotRuntimeActions {
  stop: () => Promise<void>;
}

export const CopilotRuntimeContext = createContext<CopilotRuntimeActions | null>(null);
